import React from 'react';
import { LoginButton } from '../auth';
import { TenantSwitcher } from './TenantSwitcher';
import { WorkspaceSwitcher } from './WorkspaceSwitcher';
import { MobileMenu } from './MobileMenu';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

export interface TopBarProps {
  title?: string;
}

export const TopBar: React.FC<TopBarProps> = ({ title }) => {
  return (
    <div className="flex flex-1 items-center justify-between gap-2">
      {/* Left side - Title or breadcrumb */}
      <div className="flex items-center min-w-0">
        {title && (
          <h2 className="text-xl font-semibold text-foreground truncate hidden md:block">{title}</h2>
        )}
      </div>

      {/* Right side - Actions/User menu */}
      <div className="flex items-center gap-2 shrink-0">
        {/* Search - Hidden on mobile */}
        {/* <div className="relative hidden lg:block">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            type="text"
            placeholder="Search..."
            className="w-48 xl:w-64 pl-9"
          />
        </div> */}

        {/* Workspace Switcher - Hidden on mobile */}
        <div className="hidden sm:block">
          <WorkspaceSwitcher />
        </div>

        {/* Tenant Switcher - Hidden on mobile */}
        <div className="hidden sm:block">
          <TenantSwitcher />
        </div>

        {/* Login/Logout Button - Always visible */}
        <LoginButton />

        {/* Mobile Menu - Only visible on mobile */}
        <MobileMenu />
      </div>
    </div>
  );
};